import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import { Subject } from 'rxjs';
import { ApiError } from '../../../../core/errors/api-error';
import {
  ITagListItem,
  ITagListResponse,
} from '../../../environment/tags/interfaces/tag-list-response';
import { ITagRequest } from '../../../environment/tags/interfaces/tag-request.interface';
import { EnumSituacao } from '../../../shared/enums/situacao.enum';
import { TagApi } from '../../apis/tag.api';
import { EnumCadastro } from '../../interfaces/cadastro.enum';
import { IPickListItem } from '../pick-list/models/pick-list-item.interface';
import { IPickListSettings } from '../pick-list/models/pick-list-settings.interface';
import {
  ITokenFieldSettings,
  ITokenItem,
} from '../tokenfield/tokenfield.component';
export interface ISeletorTagsSettings {
  pickListSettings: IPickListSettings;
  tokenFieldSettings: ITokenFieldSettings;
  cadastro?: EnumCadastro;
}

@Component({
  selector: 'sgt-seletor-tags',
  templateUrl: './seletor-tags.component.html',
  styleUrls: ['./seletor-tags.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SeletorTagsComponent implements OnChanges {
  @Input() selectedTags: ITokenItem[] = [];
  @Input() settings: ISeletorTagsSettings;

  tags: IPickListItem[] = [];
  showPickList = false;

  private unsubscribe$ = new Subject<void>();

  @Output() tagsChange = new EventEmitter<ITokenItem[]>();

  constructor(private tagApi: TagApi, private cdr: ChangeDetectorRef) {}

  ngOnChanges() {
    if (this.tags.length) {
      this.checkTagSelection();
    }
  }

  fetchTags() {
    const params: ITagRequest = {
      cadastros: this.settings?.cadastro ? [this.settings.cadastro] : undefined,
      situacoes: EnumSituacao.ATIVO,
    };
    this.tagApi.fetchList(params).subscribe(
      (response: ITagListResponse) => {
        this.tags = this.transformDTOToPickListItem(response.data);
        this.cdr.markForCheck();
      },
      (error: ApiError) => {
        console.error('Erro ao buscar tags:', error);
      }
    );
  }

  transformDTOToPickListItem(tags: ITagListItem[]): IPickListItem[] {
    return tags.map((tag) => ({
      id: tag.id,
      label: tag.nome,
      text: tag.descricao,
      isSelected: this.selectedTags.some(
        (selectedTag) => selectedTag.id === tag.id
      ),
    }));
  }

  openPickList() {
    this.showPickList = true;
    this.fetchTags();
  }

  closePickList() {
    this.showPickList = false;
  }

  onTagsChange() {
    this.checkSelectedTags();
  }

  checkTagSelection(): void {
    this.tags = this.tags.map((tag) => ({
      ...tag,
      isSelected: this.selectedTags.some(
        (selectedTag) => selectedTag.id === tag.id
      ),
    }));
    this.cdr.markForCheck();
  }

  /**
   * Identifica tags que foram selecionadas mas não estão em selectedTags
   */
  private getNewlySelectedTags(): any[] {
    return this.tags.filter(
      (tag) =>
        tag.isSelected &&
        !this.selectedTags.some((selected) => selected.id === tag.id)
    );
  }

  /**
   * Identifica IDs das tags que foram removidas da seleção
   */
  private getRemovedTagIds(): Array<string | number> {
    return this.selectedTags
      .filter(
        (selected) =>
          !this.tags.some((tag) => tag.id === selected.id && tag.isSelected)
      )
      .map((tag) => tag.id);
  }

  /**
   * Remove tags deselecionadas do array selectedTags
   */
  private removeUnselectedTags(removedTagIds: Array<string | number>): void {
    this.selectedTags = this.selectedTags.filter(
      (tag) => !removedTagIds.includes(tag.id)
    );
  }

  /**
   * Adiciona novas tags no final da lista selectedTags
   */
  private addNewTags(newlySelectedTags: any[]): void {
    this.selectedTags.push(...newlySelectedTags);
  }

  checkSelectedTags(): void {
    const newlySelectedTags = this.getNewlySelectedTags();
    const removedTagIds = this.getRemovedTagIds();

    this.removeUnselectedTags(removedTagIds);
    this.addNewTags(newlySelectedTags);
    this.tagsChange.emit(this.selectedTags);
  }
}
